import React from 'react'
import '../Styles/Features.css';
import image1 from '../Resource/Features/1.png';
import image2 from '../Resource/Features/2.png';
import image3 from '../Resource/Features/3.png';
import image4 from '../Resource/Features/4.png';

const Features = ({onKnowMoreClick}) => {
  return (
    <div className='Features-contianer' id=''>
        <div className='Features-sub-container'>
            <div className='Features-card-holder'>
                <div className='Features-card'>
                <div className='Features-card-image-holder'><img src={image1} className='Features-card-image'/></div>
                <div className='Features-card-liner'>
                    <div className='Features-card-header'>Premium Sustainable Living</div>
                    <div className='Features-card-content'>Expansive spaces,elevated living, and thoughtful design.</div>
                </div>
            </div>
            <div className='Features-card'>
                <div className='Features-card-image-holder'><img src={image2} className='Features-card-image'/></div>
                <div className='Features-card-liner'>
                    <div className='Features-card-header'>Luxury Rooted in Nature, Crafted for the Senses</div>
                    <div className='Features-card-content'>3 parts green, 1 part grey - tropical forest at Ramnagara.</div>
                </div>
            </div>
            <div className='Features-card'>
                <div className='Features-card-image-holder'><img src={image3} className='Features-card-image'/></div>
                <div className='Features-card-liner'>
                    <div className='Features-card-header'>Built For Three Generations</div>
                    <div className='Features-card-content'>A sanctuary for seniors, a home for generations. SRS Hills watching over the property.</div>
                </div>
            </div>
            <div className='Features-card'>
                <div className='Features-card-image-holder'><img src={image4} className='Features-card-image'/></div>
                <div className=''>
                    <div className='Features-card-header'>Escape the City, Not the Convinience</div>
                    <div className='Features-card-content'>Upcoming STRR highway exit at your door step. Chance of profit sharing from the resort.</div>
                </div>
            </div>
            </div>

            <div className='Features-enquire-now-button-holder'>
                <button className='Features-enquire-now-button' onClick={onKnowMoreClick}>Know Now</button>
            </div>
        </div>
    </div>
  )
}

export default Features
